import { render, staticRenderFns } from "./SectionGroups.vue?vue&type=template&id=2797dbed"
import script from "./SectionGroups.vue?vue&type=script&lang=ts"
export * from "./SectionGroups.vue?vue&type=script&lang=ts"
import style0 from "./SectionGroups.vue?vue&type=style&index=0&id=2797dbed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports